import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ClassRoomDetails from "ClassRoom/routes/ClassRoomDetails";
import StudentWorksheet from "ClassRoom/routes/StudentWorksheet";
import Unit from "./routes/Unit";
import Post from "./routes/Post";
import ToddleDoc from "./routes/ToddleDoc";
import ProgressReport from "./routes/ProgressReport";
import ScopeAndSequence from "Course/routes/ScopeAndSequence";
import AssessmentDetails from "Assessments/components/AssessmentDetails";
import CurriculumInsights from "CurriculumInsights";
import MessagingLink from "MessagingV2/routes/MessagingLink";
import StudentProfile from "./routes/StudentProfile";

export default store => ({
  path: "links",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "teacher-course" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    MessagingLink(store),
    ClassRoomDetails(store),
    StudentWorksheet(store),
    Unit(store),
    Post(store),
    ToddleDoc(store),
    ProgressReport(store),
    ScopeAndSequence(store),
    AssessmentDetails(store),
    CurriculumInsights(store),
    StudentProfile(store),
  ],
});
